import {config} from "../environment";
import {v4 as uuidv4} from "uuid";

export async function uploadFiles(files: Array<File>, brukerref: string, innsendingId: string = uuidv4()) {
  const formData = new FormData()
  files.forEach(file => formData.append("files", file, file.name))
  const res = await fetch(`${config.apiUrl}/api/vedlegg/${brukerref}/${innsendingId}`, {
    method: 'POST',
    body: formData,
  })
  if (!res.ok) {
    throw Error(`Unexpected response status: ${res.status}`)
  }
}
